import { render, staticRenderFns } from "./TheButtonBack.vue?vue&type=template&id=20595d88&"
import script from "./TheButtonBack.vue?vue&type=script&lang=js&"
export * from "./TheButtonBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports